<template>
    <q-card class="card-shadow q-mt-xs">
        <q-card-section>
            <transition
                appear
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
            >
                <rewards-summary :rewards="rewards" :ref-code="user.ref_code" side="operator" style="max-width: 500px"/>
            </transition>
        </q-card-section>

        <q-inner-loading :showing="loading">
            <q-spinner-gears size="50px" color="primary" />
        </q-inner-loading>
    </q-card>
</template>
<script>

import User from "../../models/User"
import RewardsSummary from "Modules/User/resources/pages/account/rewards/RewardsSummary.vue"

export default {
    name: "UserRewards",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    computed: {},
    data() {
        return {
            loading: false,
            rewards: {
                cash_earned: 0,
                savings_to_date: [],
                total_signed_up_friends: 0,
                unused: [],
                welcome_reward: 0
            }
        }
    },
    methods: {
        fetchUserRewards() {
            this.loading = true
            new User({id: this.user.id}).rewards((data) => {
                this.rewards = data
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        }
    },
    created() {
    },
    mounted() {
        this.fetchUserRewards()
    },
    watch: {},
    components: {RewardsSummary},
}
</script>
<style>

</style>
